/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import PaginationParams from '../PagenationParams'
import MealEvent from '../../event/MealEvent'

const MealPaginationState = Record(PaginationParams)

class MealPaginationStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new MealPaginationState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MealEvent.onSearch:
        return state.merge({
          page: payload.pagination.page,
          per_page: payload.pagination.per_page,
          total: payload.pagination.total
        })
    }

    return state
  }
}

export default new MealPaginationStore()
